import script from "./userDropDown.vue?vue&type=script&setup=true&lang=js"
export * from "./userDropDown.vue?vue&type=script&setup=true&lang=js"

import "./userDropDown.vue?vue&type=style&index=0&id=5a356cbe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a356cbe"]])

export default __exports__